import React from 'react';

const Unathorized = () => {
  return <div className='p-3'>
    <div className='bg-gray-200 h-full rounded rounded-md p-3 text-center '>
      <p className='text-2xl'>No cuentas con los permisos necesarios para acceder.</p>
    </div>
  </div>;
};

export default Unathorized;
